<template>
  <div id="video-wrapper">
    <div class="main-container" :class="[{'main-container--position': isHeaderInfo && currentTheme > 0},{'main-container--space':hasOptionsTv}]">
      <div
              class="video-wrapper"
              :class="[

          { [componentStyle.header + '-header']: isHeaderInfo  },
          { 'full-width': isFullWidth || hasOptionsFormation },
          { 'has-options-tv':hasOptionsTv },
          { 'has-options-formation':hasOptionsFormation },
        ]"
      >
        <!--        <b-container class="bv-example-row">-->
        <!--          <b-row>-->
        <!--            <b-col cols="10">-->
          <div class="spinner-wrapper" v-if="!(isPlayerReady && info)">
            <spinner-loader :show-text="false"></spinner-loader>
          </div>
        <div class="row" :class="[{'has-options-tv':hasOptionsTv , 'has-suggest':  isCir && (currentCategory!=='trends' || currentTheme!==0)}]">
          <div
                  :class="{
              'col-md-12': isFullWidth && isVideoHd ,
              'col-md-8': (isSideNav || hasOptions || (isFullWidth && !isVideoHd)) && !(canComment|| hasOptionsTv),
              'col-md-9':( canComment || hasOptionsTv) ,
              'col-md-10':(  isCir  && (currentCategory!=='trends' || currentTheme!==0)) ,
            }"
          >
            <div class="video-container" :class="{'has-options-tv':hasOptionsTv}">
              <iframe
                      v-if="isPlayerCDN"
                      id="iframeVideo"
                      :src="getCurrentUrlPlayer"
                      class="iframe-video"
                      frameborder="0"
                      width="100%"
                      allow="autoplay"
                      allowFullScreen
                      height="100%"
              ></iframe>
              <uep-player
                      v-if="isPlayerReady && cdnReady && !isPlayerCDN"
                      :url="currentVideo.cryptext"
                      :query="query"
                      @readyPlayer="readyPlayer"
                      @infoDetails="infoDetails"
              ></uep-player>
              <info-wrapper v-if="hasOptionsTv"
                            :info="info"
                            :player="player"
                            :class="[{ 'info-wrapper-simple': !isRM },{'has-options-tv':hasOptionsTv}]"
                            @readMore="readMore"
                            @readLess="readLess"

              ></info-wrapper>

            </div>

          </div>
          <div
                  :class="{
              'col-md-12': isFullWidth && isVideoHd,
              'col-md-4': (isSideNav || hasOptions || (isFullWidth && !isVideoHd)) && !(canComment|| hasOptionsTv),
              'col-md-3': canComment || hasOptionsTv,
            }"
          >
            <div class="suggestions" v-if="hasOptionsTv && mobileVersion"
                 :class="[{  'hidden-suggest':   isCir && (currentCategory!=='trends' || currentTheme!==0)}]">
              <HorizantalCardCarousel :desktop="true" :mobile="false" ></HorizantalCardCarousel>
            </div>
            <info-wrapper
                    v-if="!hasOptionsTv"
                    :info="info"
                    :player="player"
                    :class="[{ 'info-wrapper-simple': !isRM }]"
                    @readMore="readDesc(true)"
                    @readLess="readDesc(false)"
            ></info-wrapper>

            <modal-export
                    ref="exportModal"
                    :embedUrl="videoMedia.link_embed"
                    :embedUrlPer="videoMedia.link"
                    :interactions="interactions"
                    :textes="texts"
            >
            </modal-export>
            <div id="share-links" v-html="shareBtns"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';
    import ModalExport from '~/node_modules/modal-export/src/components/Component.vue';
    import SpinnerLoader from './common/SpinnerLoader';
    import StarRating from 'vue-star-rating';
    import VueMoment from 'vue-moment';
    import * as moment from 'moment';
    import 'moment/locale/pt-br';
    import Mixin from '@/mixins/Mixin';
    import HorizantalCardCarousel from './HorizantalCardCarousel';
    import infoWrapper from './infoWrapper';

    export default {
        name: 'mainContent',
        components: {
            ComponentVideo,
            ModalExport,
            VuePerfectScrollbar,
            SpinnerLoader,
            StarRating,
            VueMoment,
            moment,
            HorizantalCardCarousel,
            infoWrapper
        },
        props: {
            // info:'',
            shareBtns: '',
        },
        mixins: [Mixin],
        data() {
            return {
                player: {},
                shareHtml: '',
                info: '',
                interactions: [],
                loading: false,
                check: false,
                fail: false,
                visible: false,
                required: false,
                embedUrlLecture: true,
                OptionInteraction: true,
                showMore: false,
                descriptionVisible: false,
                descriptionTruncate: 200,
                playerSkin: 'dark',
                cdnReady: true,
                version: false,
                versionTablet: false,
                tokenUser: '',
                canLike: process.env.LIKE,
                mobileVersion:false
            };
        },
        computed: {
            ...mapGetters({
                currentVideo: 'videos/getCurrentVideo',
                videoMedia: 'videos/getVideoMedia',
                isFullWidth: 'layout/isFullWidth',
                isSideNav: 'layout/isSideNav',
                componentStyle: 'layout/getComponentStyle',
                videos: 'videos/getAllVideos',
                playerSkin: 'layout/getCurrentSkinPlayer',
                videoLiked: 'videos/getVideoLike',
                videoDisLiked: 'videos/getVideoDisLike',
                isVideoHd: 'layout/getIsVideoHd',
                isPlayerCDN: 'common/isPlayerCDN',
                isHeaderInfo: 'layout/isHeaderInfo',
                getNbRatingStar: 'videos/getNbRatingStar',
                isLoading: 'videos/getLoading',
                currentPage: 'videos/getCurrentPage',
                nbLike: 'videos/getNbLike',
                nbDisLike: 'videos/getNbDisLike',
                hasOptions: 'layout/hasOptions',
                hasOptionsTv: 'layout/hasOptionsTv',
                hasOptionsFormation: 'layout/hasOptionsFormation',
                currentTheme: 'videos/getCurrentTheme',
                currentCategory: 'videos/getCurrentCategory',
                playerUrl: 'videos/getPlayerUrl',

            }),
          getCurrentUrlPlayer(){
            const pathname = this.$route.name;
            let src= pathname === 'permalien' ? this.getUrlEmbedPlayer : this.currentVideo.urlLecture
            return src

          },
          getUrlEmbedPlayer() {
            if (this.currentVideo && Object.keys(this.currentVideo).length > 0) {
                if (!this.currentVideo.isIntranet || !this.currentVideo.isTl) {
                return this.currentVideo.urlLecture
              } else if (this.currentVideo.isIntranet &&  this.currentVideo.isTl) {
                return this.currentVideo.url_embed_tl
              }
            }
          },
          isCir(){
              return process.env.IS_CIR;
          },
            canComment() {
                return process.env.COMMENTS;
            },
            texts() {
                return {
                    integrations: this.$t('labels.integrations'),
                    integrations_options: this.$t('labels.integrations_options'),
                    start_video_auto: this.$t('labels.start_video_auto'),
                    default_color: this.$t('labels.default_color'),
                    start_at: this.$t('labels.start_at'),
                    share_social: this.$t('labels.share_social'),
                    copy: this.$t('buttons.copy'),
                    downloads: this.$t('labels.downloads'),
                    embedTitle: this.$t('labels.embedTitle'),
                    permalink: this.$t('labels.permalink'),
                };
            },
            isPlayerReady() {
                return this.currentVideo.cryptext && this.player;
            },
            isRM() {
                return this.isPlayerReady && this.currentVideo.type === 'isRM';
            },
            truncatedDescription() {
                if (!(this.info && this.info.description)) {
                    return '';
                }
                return this.descriptionVisible
                    ? this.info.description
                    : `${this.info.description.substring(0, this.descriptionTruncate)}...`;
            },
            query() {
                let plugin = this.currentVideo.type === 'isInteractivity' ? 'interactivity' : 'navigation';
                return { skin: this.playerSkin, plugin: plugin, a: false, ...this.$route.query };
            },
        },
        watch: {
          async playerUrl(player) {
            let id = this.$route.params.videoId ? this.$route.params.videoId : this.$route.params.playlistId;
            const pathname = this.$route.name;
            if(pathname==='permalien'){
            let current = player;
            if (!current.exist)
              this.$router.push({ name: 'error' });
            else{
              current.cryptext = current.crypted;
              current.id = parseInt(id);
                if (current.isIntranet) {
                  await this.getDeviceType(current);
                }
                await this.setCurrentVideo(current);
              }
            }
          },
            currentVideo(video) {
                this.cdnReady = false;
                setTimeout(() => {
                    this.cdnReady = true;
                }, 100);
               // if ( this.hasOptionsFormation) {
                    this.infoDetails(video);
                //}
            },
        },
        methods: {
            ...mapActions('videos', ['setCurrentVideo', 'getVideoMediaById', 'updateVotes','getCryptedUrl','getDeviceType']),

            readyPlayer(param) {
                this.player = param;
                this.updateVideoHeight();
                setTimeout(() => {
                    this.updateReadMore();
                }, 1000);
            },
            infoDetails(param) {
               this.$Progress.finish();
                if(param.nb_views)
                  param.nbviews=param.nb_views
                this.info = param;
                /*let tempElement = document.createElement("div");
                tempElement.innerHTML = this.info.description;
                  var description = document.getElementById('description')

                setTimeout(()=>{
                  if(description)
                       description.appendChild(tempElement);
                },100)*/

                this.updateVideoHeight();
                this.updateReadMore();
            },
            clickModal() {
                this.$refs.exportModal.show();
            },
            updateVideoHeight() {
                const videoWrapper = document.querySelector('.video-wrapper.full-width');
                const videoContainer = document.querySelector('.video-container');
                const uepPlayer =
                    document.querySelector('.uep_player_v2') || document.querySelector('.iframe-video');
                const namePlayer = document.querySelector('#name_player');
                //const infoWrapper = document.querySelector('.info-wrapper-simple');
                const flashPlayer = document.querySelector('object.vjs-tech');
                const videoJS = document.querySelector('.video-js');
                const html5Video = document.querySelector('.video-js video.vjs-tech');
                try {
                    const height = `${videoContainer.offsetWidth * (9 / 16)}px`;
                    if (uepPlayer) uepPlayer.style.height = height;
                    namePlayer.style.height = height;
                    if (videoJS) {
                        videoJS.style.minHeight = '100%';
                    }
                    if (
                        (flashPlayer ||
                            navigator.userAgent.indexOf('MSIE') !== -1 ||
                            navigator.appVersion.indexOf('Trident/') > -1) &&
                        !html5Video
                    ) {
                        flashPlayer.setAttribute('style', `height:${height} !important`);
                    }
                    if (videoWrapper && !this.isHeaderInfo) {
                        if (this.isFullWidth && this.isVideoHd)
                            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                        else videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 24)}px`;
                    } else {
                        if (window.innerWidth < '768') {
                            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                            videoWrapper.style.maxHeight = ``;
                        } else {
                            videoWrapper.style.maxHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
                            videoWrapper.style.minHeight = ``;
                        }
                    }
                } catch (e) {
                    // HACK for IE 11
                    setTimeout(() => {
                        this.updateVideoHeight();
                    }, 3000);
                }
                setTimeout(() => {
                    this.updateReadMore();
                }, 100);
            },
            updateReadMore() {
                const infoWrapper = document.querySelector('.info-wrapper');
                const videoJS = document.querySelector('.video-container');
                const titleEl = document.querySelector('.info-container .title');
                const descriptionEl = document.querySelector('.info-container .description');
                let metadataEl = document.querySelector('.metadata-container');
                let ps = document.querySelector('.scroll-area');
                if (this.isHeaderInfo) {
                    metadataEl = document.querySelectorAll('.metadata-container.info-header');
                }
                const btnEmbedEl = document.querySelector('.btns-wrapper');
                if (videoJS) {
                    const videoHeight = videoJS.offsetHeight;
                    let descriptionHeight = videoHeight;
                    if (titleEl) {
                        let { height, marginTop, marginBottom } = window.getComputedStyle(titleEl);
                        descriptionHeight -=
                            parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
                    }

                    if (metadataEl && !this.isHeaderInfo) {
                        descriptionHeight -= metadataEl.offsetHeight;
                    } else {
                        if (metadataEl != null) {
                            metadataEl.forEach(metaData => {
                                descriptionHeight -= metaData.offsetHeight;
                            });
                        }
                    }
                    if (btnEmbedEl) {
                        let { height, marginTop, marginBottom } = window.getComputedStyle(btnEmbedEl);
                        descriptionHeight -=
                            parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
                    }
                    if (descriptionEl) {
                        this.showMore = descriptionEl.offsetHeight > 120;
                    }

                    if(this.hasOptions){
                        this.descriptionVisible=true;
                    }
                    this.version = window.innerWidth < 768;
                    this.versionTablet = 767 <= window.innerWidth <= 992;
                    this.mobileVersion=  window.innerWidth > 992;
                    if (ps) {
                        if (this.showMore) {
                            if (this.descriptionVisible) {
                                if (this.isSideNav || this.hasOptions) {
                                    ps.style.height = `${descriptionHeight}px`;
                                } else {
                                    ps.style.height = '300px';
                                }
                            } else {
                                ps.style.height = '120px';
                            }
                        } else {
                            ps.style.height = 'auto';
                        }
                    }
                    if (infoWrapper && !this.hasOptionsTv) {
                        if (this.isSideNav || this.hasOptions) {
                            infoWrapper.style.height = `${videoHeight}px`;
                        } else {
                            infoWrapper.style.height = 'auto';
                        }
                    }
                }
            },
            readDesc(isVisible) {
                this.updateReadMore();
                setTimeout(() => {
                    window.eventhub.$emit('update-ps',isVisible)
                }, 100);
            },
        },
        created() {
          if(this.hasOptionsFormation ||this.hasOptions){
            this.paginateVideos()
          }
        },
       async mounted() {
            const pathname = this.$route.name;
            if (pathname === 'permalien') {
                let id=this.$route.params.videoId;
              await this.getCryptedUrl({v: id});

            }else{
                if (this.videos.length > 0) {
                    return this.$nextTick(() => {
                        if (!this.currentVideo || Object.keys(this.currentVideo).length === 0) {
                            if (this.videos[0]) {
                                this.setCurrentVideo(this.videos[0]);
                                if (!this.isHeaderInfo) {
                                    this.getVideoMediaById(this.videos[0].id);
                                } else {
                                    this.infoDetails(this.videos[0]);
                                }
                            }
                        }
                    });
                }
            }

            this.$nextTick(() => {
                this.updateVideoHeight();
                this.updateReadMore();
                if (this.$cookies.isKey('tokenUserFo')) {
                    this.tokenUser = this.$cookies.get('tokenUserFo');
                } else {
                    this.tokenUser = this.makeToken();
                    this.$cookies.set('tokenUserFo', this.tokenUser);
                }
            });
            window.addEventListener('resize', () => {
                this.updateVideoHeight();
                this.updateReadMore();
            });

            window.addEventListener(
                'message',
                e => {
                    try {
                        if (JSON.parse(e.data).skin) {
                            // this.playerSkin = JSON.parse(e.data).skin;
                            let video = this.currentVideo;
                            let cryptext = video.cryptext;
                            video.skin = this.playerSkin;
                            video.cryptext = '';
                            this.setCurrentVideo(video);
                            video.cryptext = cryptext;
                            this.setCurrentVideo(video);
                        }
                    } catch (e) {
                        // console.error(e);
                    }
                },
                false,
            );
        },
    };
</script>

<style scoped lang="scss">
  @import '../assets/scss/_variables';
  @import '../assets/scss/mix.scss';

  .canLike , .btn-embed{
    @media screen and (max-width: 1200px) {
      margin-top: 1em;
    }
  }

  #video-wrapper .main-container .video-wrapper .info-wrapper .btns-wrapper{
    @media screen and (max-width: 770px) {//770px
      flex-direction: row !important;
      margin-top: 0em !important;
    }
  }


  #video-wrapper {
    &.main-background {
      background-color: #fafafa;
    }
    .modal-open {
      overflow: hidden;
    }

    /deep/ {
      .modal-data {
        overflow: hidden !important;
        --modal-export-modal-data-text-align: left;
      }

      .link-data {
        --modal-export-p-text-align: left;
        --modal-export-link-data-align-items: start;
        --modal-export-link-button-margin: 0;
      }
      @media screen and (max-width: 576px) {
        .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
          flex-direction: column !important;
        }
      }
    }

    /deep/ {
      .start-at-container {
        padding-bottom: 10px;
      }

      .link-detail,
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
        align-items: start;

        p:not(.link-p) {
          min-width: 110px;
        }

        .link-p,
        .textarea-code,
        .textarea-code-iframe {
          border: 1px solid #e0e0e0 !important;
          margin: 0 10px 10px !important;
          border-radius: 2px;
          padding: 0.375rem 0.75rem;
          line-height: 1.5;
          color: #495057;
          flex-grow: 2 !important;
          @media screen and (max-width: 576px) {
            width: var(--modal-export-link-p-width, 100%) !important;
            margin: 5px 0 !important;
          }
        }

        .linkButton {
          margin: 0 !important;
          transition: 0.3s ease-in-out !important;
          min-width: 90px;

          &.is-copied {
            background: #4db6ac !important;
            color: #fff !important;
          }
        }
      }

      .link-container:last-child .link-detail {
        border-bottom: none !important;
      }
    }

    /deep/ .items.links .items.links {
      padding: 0 15px;
    }

    .main-container {
      position: relative;
      &--position{
        margin-top: 40px;
        @media screen and (max-width: 992px){
          margin-top: 140px;
        }
      }
      &--space{
        padding: 0 0.5em;
      }
      .video-wrapper {
        &:not(.has-options-tv){
          margin: 2em 0px 0;
        }
          &.has-options-tv{
            @media screen and (max-width:992px) {
              margin: 0em 10px 0 !important;
            }
          }
        .has-options-tv{
          @media screen and (max-width:992px){
            display: flex;
            flex-direction: column;
            .col-md-3{
              max-width: 100%;
              padding: 0;
            }
            .col-md-9{
              max-width: 100%;
              padding: 0;
            }
          }

        }
        &.has-options-formation{
          margin: 0.5em 0 !important;
        }
        //////modifiee
        min-height: 30vh;
        /*&:not(.info-header) {*/
        /*min-height: 30vh;*/
        /*}*/
        /*&.info-header {*/
        /*@media (max-width: 768px) {*/
        /*min-height: 30vh;*/
        /*}*/
        /*@media (min-width: 768px) {*/
        /*max-height: 30vh;*/
        /*}*/
        /*}*/
        &.full-width {
          padding: 1em;
          background-color: #eceff1;
          border-radius: 0.1em;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
          .read-more {
            background-image: linear-gradient(
                            to top,
                            #ebeef1,
                            rgba(235, 238, 241, 0.9) 50%,
                            transparent
            ) !important;
          }
        }
        &.collapsed {
          min-height: 0;
          padding: 0 1em !important;
          margin: 0 15px !important;
          overflow: hidden;
        }

        .video-container {
          width: 100%;
          min-height: 200px;
          &.has-options-tv{
            @media screen and (min-width:992px) {
              padding-top: 1em;
            }
          }
          .iframe-video {
            height: initial;
          }

          /deep/ .component {
            height: initial;
            position: relative;
            width: initial;

            .uep_player {
              height: initial;

              &.isNotRadyPlayer:not(.vjs-tech-flash) {
                display: none;
              }

              .video-player {
                height: initial;

                .video-js:not(.vjs-rich-media-with-slide) {
                  height: initial;

                  video.vjs-tech {
                    position: relative;
                  }

                  &.vjs-fullscreen object.vjs-tech {
                    min-height: 100%;
                  }
                }

                .video-js {
                  .vjs-text-track-display > div > div {
                    width: 90% !important;
                    left: 5% !important;
                    font-size: 17.1px !important;
                  }

                  &.vjs-rich-media #sliders-container #vjs-sliders-content .vjs-sliders-field {
                    width: calc(((13% - 2em) - 4px) * 1.33) !important;
                  }
                }
              }
            }
          }
        }
      }
    }

    /deep/ .modal-data {
      .column-2 {
        height: 32vw;
      }
    }

    /deep/ .start-at-container {
      display: none;
    }

    .spinner-wrapper {
      height: calc(100% - 2em);
        position: absolute;
        width: calc(100% - 4em);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .suggestions{
      width: 100%;
      height: 100%;
    }
    @media (max-width: 991px) {
      .main-container .video-wrapper {
        padding: 0.5em;
        margin: 1em 0 0;

        .info-wrapper {
         // height: auto !important;

          .info-container {
            margin-top: 2em;
            &.mobile-version,
            &.tablet-version {
              margin-top: 0em;
            }
          }
        }
      }
    }
    @media (max-width: 768px) {
      .main-container .video-wrapper {
        .info-wrapper {
          height: auto !important;
        }
      }
    }
    @media (max-width: 980px) {
      /deep/ .modal-data {
        .column-2 {
          height: auto;
        }
      }
    }

    @media only screen and (max-width: 992px) {
      .video-container {
        .iframe-video {
          height: initial;
        }
        /deep/ .component {
          .uep_player {
            .video-player {
              .video-js {
                &.skin-dark.vjs-rich-media.vjs-rich-media-with-slide {
                  &.vjs-user-inactive {
                    #dark-overlay-buttons,
                    .overlay-btns {
                      display: none;
                    }
                  }
                  .vjs-tech,
                  .vjs-slide-items {
                    height: 100% !important;
                  }
                  .vjs-big-play-button {
                    top: 50%;
                  }
                  .vjs-sliders-container {
                    display: none;
                  }
                  #dark-overlay-buttons {
                    align-items: start;
                    bottom: 3.2em !important;
                  }
                  .overlay-btns {
                    bottom: 2.2em !important;
                  }
                  .vjs-control-bar {
                    top: calc(80% - 0.2em);
                  }
                }
              }
            }
          }
        }
      }
      .suggestions{
        width: 100%;

      }
    }
    @media only screen and (max-width: 542px) {

      .suggestions{
        width: 100%;
      }
    }

    @media (min-width: 992px) {
      .col-lg-4 {
        padding-left: 5px;
      }
    }

    /*
     * IE 11 Support
     */

    .info-container {
      width: 100%;
    }

    // Modal
    .video-wrapper /deep/ .modal-overlay {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-transition: opacity 0.3s ease;
      transition: opacity 0.3s ease;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
      outline: 9999px solid rgba(0, 0, 0, 0.5);

      .modal-data {
        background-color: #fff;
        height: 32vw;
        width: 90vw;
        border-radius: 2px;
        text-align: left;
        position: absolute;
        left: 31%;
        top: 50%;
        margin-left: -26vw;
        margin-top: -33vh;
        overflow: hidden;
        z-index: 99999;
        margin-bottom: 40px;

        .row-1 {
          float: left;
          width: 100%;

          .column-1 {
            float: left;
            width: 63%;
          }

          .column-2 {
            float: left;
            width: 37%;
            padding: 0;
            overflow: auto;

            .items {
              display: inline-block;
              -ms-flex-direction: column;
              flex-direction: column;
              -webkit-box-pack: space-around;
              -ms-flex-pack: space-around;
              justify-content: space-around;
              overflow: hidden;
            }

            .links {
              width: 100%;
            }

            .tab-data {
              overflow: hidden;
              border-bottom: 1px solid #ccc;
              margin-bottom: 20px;

              button {
                background-color: #ffffff;
                float: left;
                border: none;
                outline: none;
                cursor: pointer;
                padding: 14px 16px;
                -webkit-transition: 0.3s;
                transition: 0.3s;

                .active {
                  background-color: #ffffff;
                }
              }
            }

            .interactions {
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 25px;
            }

            .link-data {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: start;
              border-bottom: none;
              margin-bottom: 10px;
            }

            p {
              font-size: 15px;
              font-weight: 300;
              position: relative;
              text-align: left;
              float: none;
              margin: 0;
              padding: 10px 5px;
              line-height: normal;
              color: #404040;
              flex-grow: 1;
            }

            .link-p {
              width: 19vw;
              word-break: break-all;
            }

            .linkButton {
              background-color: #f0f0f0;
              border: none;
              color: #8d8d8d;
              padding: 10px 25px;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              font-size: 13px;
              margin: 4px 2px;
              transition-duration: 0.4s;
              cursor: pointer;
              border-radius: 5px;
            }

            .share-icon {
              width: 20px;
              color: #888;
              margin: 1px;
            }

            .icon-interactions {
              margin: 10px;
              padding: 10px 5px;
              width: 15px;
              height: 15px;
              color: #909090;
              cursor: pointer;
            }
          }
        }

        .row-2 {
          padding: 7px;
          width: 32px;
          height: 32px;
          background-color: white;
          border-radius: 16px;
          box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
          font-size: 5px;
          margin: 10px 20px;

          .fa-times {
            cursor: pointer;
            width: 16px;
            height: 16px;
            padding: 0px;
          }
        }
      }
    }

    @media screen and (min-width: 980px) {
      /deep/ .modal-overlay .modal-data {
        height: 32vw !important;
        margin-top: -33vh !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
      }
    }

    @media screen and (max-width: 1703px) and (min-width: 980px) {
      /deep/ .modal-overlay .modal-data {
        height: 32vw !important;
        margin-top: -33vh !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
      }
    }

    @media screen and (max-width: 980px) {
      /deep/ .modal-overlay .modal-data {
        height: auto !important;
        margin-top: -44vh !important;
        overflow-y: auto !important;

        .row-1 {
          .column-2 {
            height: auto !important;
            width: 100% !important;
          }

          .column-1 {
            width: 100% !important;
          }
        }
      }
    }

    @media screen and (max-width: 1200px) and (min-width: 981px) {
      /deep/ .modal-overlay .linkButton {
        width: 100% !important;
      }
      /deep/ .modal-overlay .link-detail,
      /deep/
      .modal-overlay
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
        flex-direction: column !important;
        align-items: start !important;
        padding-bottom: 10px !important;

        .link-p,
        .textarea-code-iframe {
          width: 100% !important;
          flex-grow: 1 !important;
          margin: 0 0 8px 0 !important;
        }
      }
    }

    /deep/ input[type='color'] {
      max-width: 100px !important;
    }

    /deep/ .video-js > button.vjs-big-play-button {
      transition: none !important;
      width: 100px !important;
      height: 100px !important;
      margin-left: -50px;
      margin-top: -50px;
    }

    @media all and (-ms-high-contrast: none) {
      /deep/ {
        .video-js > button.vjs-big-play-button {
          transition: none !important;
        }
      }
    }
  }
  /deep/ .vue-star-rating {
    svg {
      width: 1.5em;
      height: 1.5em;
    }
    .vue-star-rating-rating-text {
      display: none;
    }
  }
  @media screen and (max-width: 992px) {
    .info-container {
      &.desktop-version {
        display: none !important;
      }
      &.mobile-version {
        display: flex !important;
      }
    }
  }
.has-suggest{
  display: flex;
  justify-content: center;
}
  .hidden-suggest{
    display: none!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/MainContent.vue